<template>
  <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="show">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" fab fixed bottom right color="green darken-2"><v-icon>mdi-plus</v-icon></v-btn>
    </template>
    <feed-editor title="Add a Feed" @close="show = false" @saved="show = false"/>
  </v-dialog>
</template>

<script>
import FeedEditor from './FeedEditor';

export default {
  name: 'AddFeed',
  components: {FeedEditor},
  data() {
    return {
      show: false
    };
  }
}
</script>

<style scoped>
</style>
